export default function getPresentationEditEndpoints(build) {
  return {
    getRenderData: build.query({
      query: ({ param, val }) => `/PresentationEdits/renderData/?${param}=${val}`,
      providesTags: ['RenderData'],
    }),
  };
}
